<template>
  <v-app-bar v-bind="$attrs" app height="60px">
    <slot name="menu-sidebar">
      <v-app-bar-nav-icon
        v-if="!hideHeaderAside"
        class="mr-1"
        @click.stop="currentDrawer = !currentDrawer"
      >
      </v-app-bar-nav-icon>
    </slot>
    <router-link class="black--text" :to="{ name: 'landingPage' }">
      <v-img
        contain
        max-height="40"
        max-width="40"
        src="@assets/images/logo.svg"
      ></v-img>
    </router-link>
    <v-toolbar-title class="ml-0 pl-4" :title="title">
      <router-link class="black--text" :to="{ name: 'landingPage' }">
        {{ title }}
      </router-link>
      <!-- <breadcrumb v-if="!isMobile" /> -->
    </v-toolbar-title>
    <v-spacer />
    <!-- <btn-changelang></btn-changelang> -->
    <!-- <btn-changetheme></btn-changetheme> -->
    <v-toolbar-items>
      <MenuProfile />
    </v-toolbar-items>
    <!-- <template v-slot:extension>
      <div class="d-flex full-width align-center">
        <template v-if="isMobile">
          <div class="flex-grow-0 d-flex">
            <v-badge
              bordered
              :value="typeExtension === 'breadcrumb'"
              overlap
              dot
            >
              <base-button
                @click="changeTypeExtension('breadcrumb')"
                icon
                small
                class-btn="d-inline-block"
                tooltip="sidebar.breadcrumb"
              >
                <v-icon>
                  mdi-bread-slice-outline
                </v-icon>
              </base-button>
            </v-badge>
            <v-badge bordered :value="typeExtension === 'history'" overlap dot>
              <base-button
                @click="changeTypeExtension('history')"
                icon
                small
                class-btn="d-inline-block"
                tooltip="sidebar.history"
              >
                <v-icon>
                  mdi-clock-outline
                </v-icon>
              </base-button>
            </v-badge>
          </div>
          <div
            class="flex-grow-1 overflow-hidden"
            v-show="typeExtension === 'breadcrumb'"
          >
            <breadcrumb />
          </div>
          <div
            class="flex-grow-1 overflow-hidden"
            v-show="typeExtension === 'history'"
          >
            <history-tag-view />
          </div>
        </template>
        <history-tag-view v-else />
      </div>
    </template> -->
  </v-app-bar>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { getNavbarTitle } from '../constant'
import BtnChangetheme from './part/btn-changetheme.vue'
import MenuProfile from './part/menu-profile.vue'
// import BtnChangelang from './part/btn-changelang.vue'
// import breadcrumb from './part/breadcrumb.vue'
// import HistoryTagView from './part/history-tag-view.vue'
export default {
  components: {
    // BtnChangetheme,
    MenuProfile,
    // BtnChangelang,
    // breadcrumb,
    // HistoryTagView
  },
  props: {
    drawer: Boolean,
    alwayShowDrawer: Boolean,
    hideHeaderAside: { type: Boolean, default: false },
  },
  data: () => ({
    title: getNavbarTitle(),
  }),
  computed: {
    ...mapGetters({
      typeExtension: 'setting/typeExtension',
    }),
    currentDrawer: {
      get() {
        return this.drawer
      },
      set(value) {
        this.$emit('update:drawer', value)
      },
    },
  },
  watch: {},
  methods: {
    ...mapMutations({
      changeTypeExtension: 'setting/changeTypeExtension',
    }),
    logOut() {
      this.$store.dispatch('auth/logOut').then((res) => {
        this.$store.dispatch('auth/gotologOut')
      })
    },
    gotoHome() {
      this.$router.push({ name: 'landingPage' })
    },
  },
}
</script>

<style>
.dropdown {
  text-align: center;
  min-width: 250px;
  min-height: 200px;
  padding: 15px 0;
}
.dropdown .actions {
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  padding: 10px 20px;
}
.v-card__actions .base-button {
  padding: 5px 25px !important;
}
</style>
